import { render, staticRenderFns } from "./addsubConfDialog.vue?vue&type=template&id=72cfecfa&scoped=true&"
import script from "./addsubConfDialog.vue?vue&type=script&lang=js&"
export * from "./addsubConfDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cfecfa",
  null
  
)

export default component.exports